export enum UrlSites {
  WTSTORE = 'wtstore.it',
  WELCOMETRAVELSHOP = 'welcometravelshop.it',
  VACANZEWELCOMETRAVEL = 'vacanzewelcometravel.it',
  GEOTN = 'geotn.it',
  VIMAR = 'vimarviaggi.it',
  LETOILE = 'catalogo.letoiletravel.com'
}
